import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

    constructor(public element: ElementRef, public renderer: Renderer2) { }

    @Input() size: 'small' | 'mid' | 'big';

    setSize(value) {
        this.renderer.setStyle(this.element.nativeElement.querySelector('.lds-css'), 'transform', `scale(${value}, ${value})`);
    }

    setWidthHeight(value) {
        this.renderer.setStyle(this.element.nativeElement.querySelector('.lds-spin'), 'width', `${value}`);
        this.renderer.setStyle(this.element.nativeElement.querySelector('.lds-spin'), 'height', `${value}`);
    }

    ngOnInit() {
        this.setSize((this.size === 'small'?0.25: (this.size === 'mid'?0.50:0.75)));
        this.setWidthHeight((this.size === 'small'?"20px": (this.size === 'mid'?"40px":"60px")));
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/spinner/spinner.component.ts